/** Proveedor "enlace custom" — cualquier plataforma vía URL https validada. */
import { makeExternalProvider } from "./external";

export const customLinkProvider = makeExternalProvider({
  id: "custom_link",
  name: "Enlace personalizado",
  description: "Clase en vivo por un enlace https de cualquier plataforma.",
  requiresCredentials: false,
  urlPlaceholder: "https://…",
});
